module.exports = __webpack_public_path__ + "img/undo_redo_tips.91245b79.gif";